import { render, staticRenderFns } from "./FormOtraTerapia.vue?vue&type=template&id=0d02f820"
import script from "./FormOtraTerapia.vue?vue&type=script&lang=js"
export * from "./FormOtraTerapia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports